import { apiClient } from '@/lib/api/apiClient';

export interface GameQuestionDto {
  id: string;
  questionText: string;
  questionTextAr: string;
  answer: string;
  answerAr: string;
  explanation?: string;
  explanationAr?: string;
  imageUrl?: string;           // صورة السؤال
  imageSize?: string;          // حجم صورة السؤال: small, medium, large
  answerImageUrl?: string;     // صورة الإجابة (اختياري)
  answerImageSize?: string;    // حجم صورة الإجابة
  difficulty: string;
  timeLimit: number;
  points: number;
  categoryName: string;
}

const QUESTIONS_ENDPOINT = '/api/questions';

export const playerQuestionService = {
  /**
   * Get questions for gameplay by category and difficulty
   * @param isFreeTrial تجربة مجانية - أسئلة مفعّلة للمستخدمين الجدد فقط
   * @param isPromotion وضع الترويج - أسئلة الترويج (36 سؤال مميزين) فقط
   */
  async getQuestionsForGame(
    categoryId: string,
    difficulty?: string,
    count: number = 1,
    isFreeTrial: boolean = false,
    isPromotion: boolean = false,
    excludeQuestionIds?: string[]
  ): Promise<GameQuestionDto[]> {
    try {
      const params: Record<string, string | number | boolean> = { categoryId, count };
      if (difficulty) {
        params.difficulty = difficulty;
      }
      if (isFreeTrial) params.isFreeTrial = true;
      if (isPromotion) params.isPromotion = true;
      if (excludeQuestionIds && excludeQuestionIds.length > 0) {
        params.excludeQuestionIds = excludeQuestionIds.join(',');
      }

      const response = await apiClient.get(QUESTIONS_ENDPOINT, { params });
      return response.data.data || [];
    } catch (error) {
      console.error('Failed to fetch questions:', error);
      return [];
    }
  },

  /**
   * Get a single random question for a category and difficulty.
   * excludeQuestionIds: عدم تكرار السؤال للاعب الدافع - استبعاد الأسئلة المعروضة مسبقاً في الجلسة.
   */
  async getRandomQuestion(
    categoryId: string,
    difficulty: 'Easy' | 'Medium' | 'Hard',
    isFreeTrial: boolean = false,
    isPromotion: boolean = false,
    excludeQuestionIds?: string[]
  ): Promise<GameQuestionDto | null> {
    const questions = await this.getQuestionsForGame(
      categoryId,
      difficulty,
      1,
      isFreeTrial,
      isPromotion,
      excludeQuestionIds
    );
    return questions.length > 0 ? questions[0] : null;
  },
};
